import React from "react";
import RegistrationForm from "../../Components/RegistrationForm/RegistrationForm";
import StripeForm from "../../Components/StripeForm/StripeForm";
import jwt_decode from "jwt-decode";
import GooLoader from "../../Components/GooLoader/GooLoader";
import { Helmet } from "react-helmet-async";
import "./Payment.css";

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customerName: "",
      customerEmail: "",
      isLoading: true,
    };

    this.handleStripeSubmit = this.handleStripeSubmit.bind(this);
  }

  componentDidMount() {
    let token = localStorage.getItem("token");
    if (!token) {
      this.props.history.push("/");
    } else {
      let decoded = jwt_decode(token);
      if (decoded.active) {
        this.props.history.push("/dashboard");
      } else {
        if (
          this.props.location.state === undefined ||
          !this.props.location.state.userData
        ) {
          this.props.history.push("/");
        } else {
          let userData = this.props.location.state.userData;
          let { policy_agreements } = userData;
          if (!policy_agreements) {
            this.props.history.push("/policy-agreement", {
              userData: userData,
            });
          } else {
            this.setState({
              isLoading: false,
            });
          }
        }
      }
    }
  }

  handleStripeSubmit() {
    let userData = this.props.location.state.userData;
    this.props.history.push("/payment-accepted", {
      userData: {
        ...userData,
        paymentAcceptedShow: false,
      },
    });
  }

  // handleBack() {
  //   this.props.history.goBack();
  // }

  render() {
    return (
      <React.Fragment>
        {this.state.isLoading ? <GooLoader /> : null}

        <RegistrationForm
          containerClassName="container-payment"
          hasCounter={false}
          hasQuote={true}
          quote="We're looking forward to learning from you! The last step is to pay. Astronomic Network costs $49/month."
          headerText="Payment"
          showButton={false}
          hasSkip={false}
          showBackButton={false}
        >
          <Helmet>
            <title>Astronomic Network</title>
            <meta
              name="description"
              content="Austin entrepreneurs helping each other win"
            />
          </Helmet>

          <div className="form-container-body-row">
            <StripeForm handleStripeSubmit={this.handleStripeSubmit} />
          </div>
        </RegistrationForm>
      </React.Fragment>
    );
  }
}

export default Payment;
